export const getConstants = (state) => state.constants;
